import { get } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const productService = {
  /**
   * Get products for quotation builder from inventory endpoint
   */
  getProducts: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.search) queryParams.append('search', filters.search);
      if (filters.category) queryParams.append('category', filters.category);
      // Always include limit - default to 20 if not provided
      queryParams.append('limit', filters.limit || 20);

      const url = `${API_ENDPOINTS.CRM.INVENTORY}?${queryParams.toString()}`;

      const response = await get(url);
      
      if (response && response.responseCode === 200) {
        // Handle different response structures
        let productsArray = [];
        
        if (response.data) {
          // Check if data has inventory array (from /crm/marg/inventory endpoint)
          if (Array.isArray(response.data.inventory)) {
            productsArray = response.data.inventory;
          } 
          // Check if data is directly an array
          else if (Array.isArray(response.data)) {
            productsArray = response.data;
          }
          // Check if data has products array
          else if (Array.isArray(response.data.products)) {
            productsArray = response.data.products;
          }
        }
        
        return {
          success: true,
          products: productsArray
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to retrieve products',
          products: []
        };
      }
    } catch (error) {
      
      return {
        success: false,
        error: error.message || 'Failed to retrieve products',
        products: []
      };
    }
  }
};

export default productService;

